// extracted by mini-css-extract-plugin
export var actions = "_1j-0";
export var actionsContainer = "_1j-6";
export var border = "_1j-1";
export var childFullHeight = "_1j-d";
export var collapse = "_1j-2";
export var content = "_1j-8";
export var contentChild = "_1j-c";
export var fullscreen = "_1j-a";
export var headerContainer = "_1j-3";
export var headerRow = "_1j-5";
export var hidePadding = "_1j-9";
export var noScrollX = "_1j-e";
export var noScrollY = "_1j-f";
export var optOutTopPadding = "_1j-b";
export var pagePadding = "_1j-7";
export var profile = "_1j-g";
export var profileContainer = "_1j-h";
export var profileImage = "_1j-i";
export var profileMain = "_1j-j";
export var profileSubtitle = "_1j-l";
export var profileTitle = "_1j-k";
export var tabsWrapper = "_1j-4";
export var title = "_1j-m";